import React, { useEffect, useMemo, useState } from 'react'
import { clone } from 'lodash-es'
import { createForm } from '@formily/core'
import { requestIdle } from '@designable/shared'
import { CheckCircleOutlined, SearchOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, Tag, Form, Input, Space, message } from 'antd'
//@ts-ignore
import Modal from "@/components/Modal/Modal";
//@ts-ignore
import Table from "@/biz/Table";
import Select from '@/components/Form/Select.jsx'
import StateData from '@/pages/MainPage/datas/StateData';
// import Table from '@/components/Table/Table';
import type { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import type { FilterValue, SorterResult } from 'antd/es/table/interface';
//@ts-ignore
import useHTTP from '@/hooks/useHTTP.mjs'
import cls from 'classnames'
import { useStore } from '../../../store'
import { BusinessScenarioType } from '../types'
import parseMap from '@/components/SoftwareMap/scripts/parseMap.mjs';
// import './styles.less'

const roleType = [
  ['ROLE', '角色']
]

interface IClickEventSetterProps {
  value?: BusinessScenarioType
  onChange?: (value: BusinessScenarioType) => void
}

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Record<string, FilterValue>;
}

const columns = [
  {
    title: "知识模块名称",
    dataIndex: "rmName",
    component: <Table.ViewText />,
  },
  {
    title: "知识模块代码",
    dataIndex: "rmNo",
    component: <Table.ViewText />,
  },
  // {
  //   title: "规则类型",
  //   dataIndex: "ruleType",
  //   component: <Table.ViewDict dict={Object.fromEntries(roleType)} />,
  // },
  {
    title: "角色标题",
    dataIndex: "ruleTitle",
    component: <Table.ViewText />,
  },
  {
    title: "角色代码",
    dataIndex: "ruleUserCode",
    component: <Table.ViewText />,
  },
  {
    title: "描述",
    dataIndex: 'desc',
    getValue: (data) => {
          const fileIdData = data?.ruleMap && JSON.parse(data?.ruleMap)
          ? parseMap(data?.ruleMap)[0]
          : undefined;
          return fileIdData?.data?.arName || undefined
    },
    component: <Table.ViewText />
  },
  {
    title: "版本号",
    dataIndex: "ver",
    width: 60,
    getValue: ({ rev, sVer }) => `${sVer}.${rev}`,
    component: <Table.ViewText />,
  },
].filter((v) => v);


export const RoleModal: React.FC<IClickEventSetterProps> = (props) => {
  const http = useHTTP();
  const prjData = useStore((s) => s.prjData);
  const [tabeleData, setTableData] = useState();
  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });
  const [modalVisible, setModalVisible] = useState(false)
  const [innerVisible, setInnerVisible] = useState(false)
  const copyVal = typeof props.value == 'string' ?  { name: props.value, id: ''} : clone(props.value);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState<BusinessScenarioType>(undefined);
  
  const initval = {
    uiUserCode: '',
    uiName: ''
  }
  
  useEffect(() => {
    if (modalVisible) {
      setSelectedRowKeys(copyVal?.id ? [copyVal.id] : [])
      setSelectedRow(copyVal || {})
      requestIdle(
        () => {
          setInnerVisible(true)
        },
        {
          timeout: 100,
        }
      )
      fetchData(initval);
    } else {
      setInnerVisible(false)
    }
  }, [modalVisible])
  const form = useMemo(() => {
    return createForm({
      values: {
        ...copyVal
      },
    })
  }, [modalVisible, props.value])
  const openModal = () => setModalVisible(true)
  const closeModal = () => setModalVisible(false)
  const handleRowClick = (record) => {
    setSelectedRowKeys([record.pkid]);
    setSelectedRow({id: record.pkid,  name: record.ruleTitle})
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, selectedRows) => {
      setSelectedRowKeys(keys);
      const record = selectedRows[0]
      setSelectedRow({id: record.pkid,  name: record.ruleTitle})
    },
  };

  const fetchData = (query?: any) => {
    setLoading(true);
    http.get('/rulemRm/getRulemRmRules', {
      prjId: prjData.prjId,
      sVer: prjData.sVer,
      ruleType: "ROLE",
      ...query,
    }).then((data) => {
        setTableData(data)
        setLoading(false);
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: 200,
          },
        });
      }).catch(err => {
        setLoading(false);
      });
  };

  const onFinish = (values: any) => {
    fetchData(values);
  };

  return (
    <>
      <div className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white shadow-xs hover:shadow-md">
        <div className="flex w-0 grow items-center space-x-1 rounded-lg bg-components-input-bg-normal hover:bg-components-input-bg-normal">
          <Input
            value={copyVal?.name}
            bordered={false}
            readOnly
          />
        </div>
        {copyVal?.id && <div
          title="清除角色"
          onClick={() => props.onChange(undefined)}
          className="flex h-full shrink-0 items-center py-2 pl-2 pr-2.5 border-r-[1px]"
        >
          <CloseCircleOutlined />
        </div>}
        <div
          title="选择角色"
          onClick={openModal}
          className="flex h-full shrink-0 items-center py-2 pl-2 pr-2.5"
        >
          <SearchOutlined />
        </div>
      </div>  
      <Modal
        title="关联角色"
        width={1280}
        style={{ top: 20 }}
        bodyStyle={{
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          maxHeight: "calc(80vh - 100px)",
          minHeight: 320,
          background: "#fff",
          padding: "16px 24px",
        }}
        centered
        transitionName=""
        maskTransitionName=""
        open={modalVisible}
        onCancel={closeModal}
        destroyOnClose
        onOk={() => {
          if (selectedRowKeys && selectedRowKeys.length > 0) {
            props.onChange(selectedRow);
            closeModal();
          } else {
            message.warning("请先进行选择");
          }
        }}
      >
        {innerVisible && (
          <>
            <Form
              name="queryForm"
              // labelCol={{ span: 8 }}
              // wrapperCol={{ span: 16 }}
              layout="vertical"
              initialValues={initval}
              onFinish={onFinish}
              autoComplete="off"
              size="middle"
            >
              <Space>
                <Form.Item name="rmName" label="知识模块名称">
                  <Input size="middle" placeholder="请输入" allowClear />
                </Form.Item>
                <Form.Item name="rmNo" label="知识模块代码">
                  <Input size="middle" placeholder="请输入" allowClear />
                </Form.Item>
                <Form.Item name="ruleTitle" label="角色标题">
                  <Input size="middle" placeholder="请输入" allowClear />
                </Form.Item>
                <Form.Item name="ruleUserCode" label="角色代码">
                  <Input size="middle" placeholder="请输入" allowClear />
                </Form.Item>
           
       

                <Form.Item
                  style={{ width: "120px" }}
                  label=" "
                  wrapperCol={{ offset: 8 }}
                >
                  <Button
                    //@ts-ignore
                    icon={<SearchOutlined />}
                    type="primary"
                    htmlType="submit"
                  >
                    搜索
                  </Button>
                </Form.Item>
              </Space>
            </Form>

            <Table
              loading={loading}
              rowSelection={{
                type: "radio",
                ...rowSelection,
              }}
              rowKey={"pkid"}
              columns={columns}
              dataSource={tabeleData}
              onRow={(record) => ({
                onClick: () => handleRowClick(record), // 点击行选中
              })}
            />
          </>
        )}
      </Modal>
    </>
  );
}
